import React, { Component } from 'react';
import {
    Row, Col, Breadcrumb, BreadcrumbItem, Button, Card, CardHeader
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './usage-stats.scss';
// import DatePicker from 'react-datepicker';

import CreditUsageBody from './Table/index';
import { downloadCreditUsageDataSuccess, downloadCreditUsageData, fetchCreditUsageData, fetchCreditUsageGraphTileData, fetchProductNameData } from './action';
import { getZone } from '../../Analyst/Cases/Create/actions'
import FilterTemplateClass from './ApplyFilter/FilterTemplateClass'
import StackedGraph from './ApplyFilter/StackedGraph'
//import { makeChartInfo } from './helper';
import fileSaver from 'file-saver';
import 'react-datepicker/dist/react-datepicker.css';
import withAuth from '../../components/Services/WithAuth';
import { listOfColumnNames, fetchData, sortColumn, ascSort, descSort, DEFAULT_REQUEST_BODY } from './constant';
import { fetchProductTypeDetails } from '../my-portfolio/action';
// import Modal from '../../components/UI/Modal/Modal';
import _ from 'lodash';
import { ProductTypesPop } from '../productTypesPop';
import { MODAL_TYPE_SUCCESS, MODAL_TYPE_FORM } from '../../constants';
import CorporateModal from '../../components/UI/CorporateModal';
import { Preloading } from '../../components/UI/Preloader/action';
import ReactPaginate from 'react-paginate';
import { pageLink, currentLink } from '../my-portfolio/helper';
import { setPageView, goolgeAnalyticsEvents } from '../../components/GoogleAnalytics/index';

class CreditUsage extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
        this.applyCreditUsageFiltersAction = this.applyCreditUsageFiltersAction.bind(this);
        this.doSort = this.doSort.bind(this);
        this.state = {
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_FORM,
            modalTitle: '',
            modalCloseHandler: () => { },
            popoverOpen: false,
            creditUsageData: {
                creditviewList: [],
                numberOfPages: 0
            },
            creditsReportMetadata: [],
            totalCredits: 0,
            creditsUsed: 0,
            sortInfo: [{
                columnName: sortColumn,
                sortOrder: ascSort
            }],
            ColumnNames: listOfColumnNames,
            showGraphTile: false,
            showGraphTileError: false,
            showGridDataError: false,
            showGridData: true,
            showGraphTileErrorMsg: '',
            showGridDataErrorMsg: '',
            test: [],
            zoneList: [],
            currentPage: 0,
            appliedFilters: {
                fromDate: null,
                toDate: null,
                reportTypes: [],
                region: []

            },
            sortField: 'dueOrCompletedDate',
            sortType: 'desc'
        };

    }
    componentDidMount() {
        setPageView('/Corporate/usage-stats', document.location.href);
        this.props.fetchProductTypeDetails();
        this.props.getZone();
        //this.props.fetchCreditUsageGraphTileData();
        this.props.fetchCreditUsageData(DEFAULT_REQUEST_BODY);
        this.setState({
            appliedFilters: DEFAULT_REQUEST_BODY.fetchData
        });
        this.props.preloading(true)
    }
    componentDidUpdate(prevProps) {
        if (this.props.zoneList !== prevProps.zoneList) {
            this.setState({
                zoneList: this.props.zoneList
            })
        }
        // If download credit usage was successful
        if (this.props.downloadCreditUsageDataValues !== prevProps.downloadCreditUsageDataValues) {
            var blob = new Blob([this.props.downloadCreditUsageDataValues.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            fileSaver.saveAs(blob, 'Credit_Usage.xlsx');
            this.props.preloading(false);
            goolgeAnalyticsEvents('Corporate', 'Download Credit Usage Excel File', 'Download', '');
        }
        if (this.props.downloadCreditUsageDataFailure !== prevProps.downloadCreditUsageDataFailure) {
            this.props.preloading(false);
        }
        /*if (this.props.fetchCreditUsageGraphTileDataError &&
            this.props.fetchCreditUsageGraphTileDataError !== prevProps.fetchCreditUsageGraphTileDataError) {
            this.setState({
                showGraphTile: false
            });
        }*/

        if (this.props.fetchCreditUsageDataValues !== prevProps.fetchCreditUsageDataValues) {
            let data = Object.assign({}, this.props.fetchCreditUsageDataValues.data)
            this.setState({
                creditUsageData: this.props.fetchCreditUsageDataValues.data, //_.orderBy(data, [sortColumn], [ascSort]),
                popoverOpen: false
            })
            this.props.preloading(false)
        }
        if (this.props.fetchCreditUsageDataFailure !== prevProps.fetchCreditUsageDataFailure) {
            this.props.preloading(false)
        }
        /*if (this.props.fetchCreditUsageGraphTileDataValues !== prevProps.fetchCreditUsageGraphTileDataValues) {
            this.setState({
                showGraphTile: true,
                totalCredits: this.props.fetchCreditUsageGraphTileDataValues.data.totalCredits,
                creditsUsed: this.props.fetchCreditUsageGraphTileDataValues.data.creditsUsed
            })
            makeChartInfo(this.props.fetchCreditUsageGraphTileDataValues.data.creditsReportMetadata, this.props.fetchCreditUsageGraphTileDataValues.data.unusedCredits);
        }*/

    }

    doSort(key) {
        this.props.preloading(true)
        let sortDirection;
        if (this.state.sortType === descSort) {
            sortDirection = ascSort
        } else {
            sortDirection = descSort
        }
        this.setState({
            sortField: key,
            sortType: sortDirection
        })
        const requestBody = {
            pageNumber: 0,
            pageSize: 10,
            sortfield: key,
            sortDirection: sortDirection,
            fetchData: this.state.appliedFilters
        }
        this.props.fetchCreditUsageData(requestBody);
        /* let data = this.props.fetchCreditUsageDataValues.data;
        let creditUsageData = [];
        let sortInfo = [];
        let obj = {}
        if (this.state.sortInfo[0].columnName === e.target.attributes.displaycolumnname.value) {
            if (this.state.sortInfo[0].sortOrder === ascSort) {
                creditUsageData = _.orderBy(data, [e.target.attributes.realcolumnname.value], [descSort]);
                obj.columnName = e.target.attributes.displaycolumnname.value
                obj.sortOrder = descSort
            }
            else {
                creditUsageData = _.orderBy(data, [e.target.attributes.realcolumnname.value], [ascSort]);
                obj.columnName = e.target.attributes.displaycolumnname.value
                obj.sortOrder = ascSort
            }
        } else {
            creditUsageData = _.orderBy(data, [e.target.attributes.realcolumnname.value], [ascSort]);
            obj.columnName = e.target.attributes.displaycolumnname.value
            obj.sortOrder = ascSort
        }
        sortInfo.push(obj);
        this.setState({
            creditUsageData: creditUsageData,
            popoverOpen: false,
            sortInfo: sortInfo
        }) */
    }

    downloadReport() {
        this.props.preloading(true);
        this.props.downloadCreditUsageData(this.state.appliedFilters);
    }

    toggle() {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }
    applyCreditUsageFiltersAction(data) {
        this.props.preloading(true)
        if(data.fromDate === 'Invalid date') {
            data.fromDate = null;
            data.toDate = null;
        }
        this.setState({
            popoverOpen: !this.state.popoverOpen,
            appliedFilters: data
        });
        const requestBody = {
            pageNumber: 0,
            pageSize: 10,
            sortfield: 'dueOrCompletedDate',
            sortDirection: 'desc',
            fetchData: data
        }

        this.props.fetchCreditUsageData(requestBody);
        goolgeAnalyticsEvents('Corporate', 'Applied Credit Usage Filters', 'Apply filters', '');
    }
    productTypeDescription = () => {
        goolgeAnalyticsEvents('Corporate', 'View Credit Usage Product Type', 'Credit Usage Product Type', '');
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body:
                <ProductTypesPop productTypes={this.props.productDetails} />,
            modalType: MODAL_TYPE_SUCCESS,
            modalTitle: 'Products Subscribed',
            modalCloseHandler: this.toggleModal
        }))
    }
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }

    handlePagination = (i) => {
        goolgeAnalyticsEvents('Corporate', 'Update Credit Usage Page Number', 'Credit Usage Pagination', i + 1);
        this.props.preloading(true);
        const requestBody = {
            pageNumber: i,
            pageSize: 10,
            sortfield: this.state.sortField,
            sortDirection: this.state.sortType,
            fetchData: this.state.appliedFilters
        }
        //Request Body
        this.setState({
            currentPage: i
        })
        this.props.fetchCreditUsageData(requestBody);
    }

    render() {
        // let self = this;
        /* let gridHeader = this.state.ColumnNames.map((p, index) => {
            if (self.state.sortInfo.find(x => x.columnName === p.colName) != null) {
                if (index === 0) {
                    return (
                        <Col sm="4" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}<i className="icon-updown ml-2"></i></Col>
                    )
                }
                if (index === 1) {
                    return (
                        <Col sm="6" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}<i className="icon-updown ml-2"></i></Col>
                    )
                }
                if (index === 4) {
                    return (
                        <Col sm="4" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}<i className="icon-updown ml-2"></i></Col>
                    )
                }
                else {
                    return (
                        <Col sm="5" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}<i className="icon-updown ml-2"></i></Col>
                    )
                }
            }
            else {
                if (index === 0) {
                    return (
                        <Col sm="4" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}</Col>
                    )
                }
                if (index === 1) {
                    return (
                        <Col sm="6" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}</Col>
                    )
                }
                if (index === 4) {
                    return (
                        <Col sm="4" className="custom-table-header-title cursor-pointer p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}</Col>
                    )
                }
                else {
                    return (
                        <Col sm="5" className="custom-table-header-title p-3" realcolumnname={p.title} displaycolumnname={p.colName} key={index}>{p.colName}</Col>
                    )
                }
            }
        }) */
        return (
            <Col>
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Usage Stats</BreadcrumbItem>
                    <BreadcrumbItem active>Records</BreadcrumbItem>
                </Breadcrumb>
                {/* Commented Credit Usage graph after discussion with Ankita on 18-02-2021 */}
                {/*<Row className={this.state.showGraphTile ? "d-block" : "d-none"}>
                    <Col className="mb-3">
                        <Card className="card-credit-usage">
                            <CardHeader className="d-flex flex-column flex-sm-row justify-content-sm-between px-3">
                                <span className="card-credit-usage-label">Credit Usage</span>
                                <span className="card-credit-usage-result">
                                    <span>Consumed credits </span>
                                    <span className='fa fa-inr'>&nbsp;</span>
                                    <span><strong>{this.state.creditsUsed}</strong></span>
                                    <span> of </span>
                                    <span className='fa fa-inr'>&nbsp;</span>
                                    <span><strong>{this.state.totalCredits}</strong></span>
                                </span>
                            </CardHeader>
                            <StackedGraph></StackedGraph>
                        </Card>
                    </Col>
                </Row>*/}
                <Row className="d-flex justify-content-end no-gutters mb-3 position-relative">
                    <div className="filter-wrapper">
                        <Button id="Popover1" className="mr-3 btn-icon btn-filter credit-filter-button" style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} outline size="sm" onClick={this.toggle}>
                            <i className="icon-filter"></i>
                        </Button>

                        <Button style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} size="sm" className="min-w-15 download-credit-report" onClick={this.downloadReport}>Download Report Statement</Button>
                    </div>
                    <div className={this.state.popoverOpen ? "position-absolute filter-popover d-block bg-light p-4" : "position-absolute filter-popover d-none p-4"}>
                        <FilterTemplateClass regionListItems={this.state.zoneList} repoortTypeListItems={this.props.productDetails} hideCreditUsageFilterCallback={this.toggle} applyCreditUsageFiltersCallBack={this.applyCreditUsageFiltersAction}>
                        </FilterTemplateClass>
                    </div>
                </Row>
                <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex">
                    {/* {gridHeader} */}
                    <Col sm="4" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('corporateName')}>Subsidiary / Division Name<i className={(this.state.sortField === 'corporateName') ? "icon-updown ml-2" : ''}></i></Col>
                    <Col sm="3" className="custom-table-header-title cursor-auto p-3" >Requested By</Col>
                    <Col sm="4" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('counterpartyName')}>Company Name<i className={(this.state.sortField === 'counterpartyName') ? "icon-updown ml-2" : ''}></i></Col>
                    <Col sm="5" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('productId')}>Report Type<i className={(this.state.sortField === 'productId') ? "icon-updown ml-2" : ''}></i></Col>
                    <Col sm="1" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('riskScore')}>Rubix Score<i className={(this.state.sortField === 'riskScore') ? "icon-updown ml-2" : ''}></i></Col>
                    <Col sm="1" className="custom-table-header-title cursor-auto p-3" >Rubix Risk Grade</Col>
                    <Col sm="2" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('state')}>State<i className={(this.state.sortField === 'state') ? "icon-updown ml-2" : ''}></i></Col>
                    <Col sm="2" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('country')}>Country<i className={(this.state.sortField === 'country') ? "icon-updown ml-2" : ''}></i></Col>
                    <Col sm="2" className="custom-table-header-title cursor-pointer p-3" onClick={() => this.doSort('dueOrCompletedDate')}>Delivery Date<i className={(this.state.sortField === 'dueOrCompletedDate') ? "icon-updown ml-2" : ''}></i></Col>
                </Row>

                <div className="gridBodyWrapper">
                    <CreditUsageBody creditUsageData={this.state.creditUsageData} productDescription={this.productTypeDescription}></CreditUsageBody>
                    <div className="paginate-portfolio">
                        {(this.state.creditUsageData) ? <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={pageLink}
                            previousClassName={pageLink}
                            nextClassName={pageLink}
                            pageClassName={pageLink}
                            activeClassName={currentLink}
                            initialPage={this.state.currentPage}
                            pageCount={this.state.creditUsageData.numberOfPages}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={10}
                            onPageChange={i => {
                                this.handlePagination(i.selected)
                            }}
                            /> : ''}
                    </div>
                </div>

                <CorporateModal toShow={this.state.showModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle} />
            </Col>

        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    productNameData: state.ceditUsageReducer.fetchProductNameSuccess,
    zoneList: state.createCase.zoneList,
    downloadCreditUsageDataValues: state.ceditUsageReducer.downloadCreditUsageData,
    downloadCreditUsageDataFailure: state.ceditUsageReducer.downloadCreditUsageDataFailure,
    fetchCreditUsageDataValues: state.ceditUsageReducer.fetchCreditUsageDataSuccess,
    fetchCreditUsageDataFailure: state.ceditUsageReducer.fetchCreditUsageDataFailure,
    //fetchCreditUsageGraphTileDataValues: state.ceditUsageReducer.fetchCreditUsageGraphDataSuccess,
    //fetchCreditUsageGraphTileDataError: state.ceditUsageReducer.fetchCreditUsageGraphDataFailure,
    productDetails: state.portfolio.productTypeDetails,
    productDetailsFailure: state.portfolio.productTypeDetailsFailure,
    corporateColor: state.corporate.corporateColor
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchProductNameData: () => { dispatch(fetchProductNameData()) },
    getZone: () => { dispatch(getZone()) },
    fetchCreditUsageData: (data) => { dispatch(fetchCreditUsageData(data)) },
    //fetchCreditUsageGraphTileData: () => { dispatch(fetchCreditUsageGraphTileData()) },
    downloadCreditUsageData: (data) => { dispatch(downloadCreditUsageData(data)) },
    fetchProductTypeDetails: () => { dispatch(fetchProductTypeDetails()) },
    downloadCreditUsageDataSuccess: (data) => { dispatch(downloadCreditUsageDataSuccess(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});
export default CreditUsage = withAuth(connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditUsage))

